<template>

  <app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">
    <div slot="icons">

      <v-tooltip  allow-overflow open-delay="800"
         left max-width="250">
          <v-icon slot="activator"  v-bind:class="{actives: fastUpdating.auto}"  v-if="!updating.auto"  @click="fastAutoStarter()" >mdi-flash</v-icon>
          <span> Авто  обновление сообществ в которые вступили новые участники прямо сейчас</span>
       </v-tooltip>







       <v-tooltip  allow-overflow open-delay="800"
          left max-width="250">
        <v-icon v-if="!fastUpdating.auto" slot="activator" v-bind:class="{actives: updating.auto}" @click="autoUpdaterStarter()">mdi-autorenew</v-icon>
        <span> Периодическое обновление выбранных ({{this.groups.checkList.length}}) сообществ, задать период обновления можете в настройках приложения, по умолчанию 572 </span>
       </v-tooltip>

        <v-tooltip  allow-overflow open-delay="800"
           left max-width="250">
        <v-icon slot="activator" @click="updaterMembers(groups.checkList[0])" >mdi-update</v-icon>
        <span> Обновить список выбранных  ({{this.groups.checkList.length}}) сообществ </span>
        </v-tooltip>


        <v-tooltip  allow-overflow open-delay="800"
           left max-width="250">
        <v-icon  slot="activator" medium @click="closeUpdater()">mdi-close</v-icon>
        <span> Закрыть обновления сообществ</span>
        </v-tooltip>



    </div>


    <span slot="status">
      <span v-if="updating.inProccess"  style="font-size:1.3em; margin:5px;color:#727272">  ID: {{updating.groupName}}  {{updating.updatingPercent.toFixed() }} %  </span>
      <span v-if="!updating.inProccess &&  updating.auto"  style="font-size:1.3em; margin:5px;color:#727272">   Обновление через  {{autoUpdater }}    </span>
     </span>

<div slot="starter"   class="text-xs-center" v-if="starter">
  <p style="padding:15px">
      Данная возможность позволяет получить список новых подписчиков
      и тех кто отписался в
      выбранных вами сообществаx
  </p>

<v-btn  @click="starter = false;updaterMembers(groups.checkList[0])" color="primary"> Обновить выбранные сообщества</v-btn>
</div>
<div slot="operations">


  <v-dialog  v-model="autoparams" width="500">
<v-card>
<v-card-text>

  <p style="color:#757575;font-size:1.3em"> Через какое время обновлять процесс  ?</p>
    <v-layout row>



      <v-flex class="px-3">
        <v-subheader>Часы</v-subheader>
       <v-slider
       max="23"
       v-model="updating.intervalSet.hours"
       color="primary"
       thumb-label="always"
       ></v-slider>
       </v-flex>

       <v-flex class="px-3">
         <v-subheader>Минуты</v-subheader>
        <v-slider
        v-model="updating.intervalSet.min"
        max="59"
        color="primary"
        thumb-label="always"
        ></v-slider>
        </v-flex>


      <v-flex class="px-3">
        <v-subheader>Секунды</v-subheader>
        <v-slider
        v-model="updating.intervalSet.sec"
        max="59"
        color="primary"
        thumb-label="always"
        ></v-slider>
        </v-flex>








    </v-layout>

</v-card-text>
<v-card-actions>
<v-btn  @click="autoUpdaterStart()" block color="primary">Сохранить </v-btn>
</v-card-actions>
</v-card>
  </v-dialog>





<v-dialog width="500" v-model="fastAutoParams" scrollable>
  <v-card>

<v-card-title>
<h3 style="color:#4A76A8">  Авто определение вступлений  </h3>
<v-spacer></v-spacer>
<v-icon @click="fastAutoParams = false">mdi-close</v-icon>
</v-card-title>
<hr style="background:#4A76A8"> </hr>
    <v-card-text>




<p style="color:#757575;font-size:1.3em">
 Колличество вступлений при котором запускать авто обновление
</p>


 <div style="margin:5px; width:450px">

      <v-subheader>Сообщества от 100 000 человек</v-subheader>

      <v-slider
      v-model="fastUpdating.groups.from100000.sensitivity"
      max="500"
      color="primary"
      thumb-label="always"
      ></v-slider>

      <v-subheader>Сообщества от 10 000 до 100 000 человек</v-subheader>

      <v-slider
      v-model="fastUpdating.groups.to100000.sensitivity"
      max="500"
      color="primary"
      thumb-label="always"
      ></v-slider>

      <v-subheader>Сообщества от 1 000 до 10 000 человек</v-subheader>

      <v-slider
      v-model="fastUpdating.groups.to10000.sensitivity"
      max="500"
      color="primary"
      thumb-label="always"
      ></v-slider>

      <v-subheader>Сообщества от 100 до 1 000 человек</v-subheader>

      <v-slider
      v-model="fastUpdating.groups.to1000.sensitivity"
      max="100"
      color="primary"
      thumb-label="always"
      ></v-slider>

            <v-subheader>Сообщества до 100 человек</v-subheader>

            <v-slider
            v-model="fastUpdating.groups.to100.sensitivity"
            max="10"
            color="primary"
            thumb-label="always"
            ></v-slider>


  </div>


<div>
<v-subheader>Чувствительность (сек.)</v-subheader>
            <v-slider
            v-model="fastUpdating.sensor"
            max="300"
            color="primary"
            thumb-label="always"
            ></v-slider>
</div>

<div>
<v-checkbox
v-model="turbo"
label="Активировать турбо режим"
/>
</div>



    </v-card-text>
    <v-card-actions>
    <v-btn  @click="fastAutoStart()" block color="primary">Сохранить </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<v-checkbox
v-model="saveInfoOfSourceNewIn"
label="Запоминать куда вступили новые подписчики ?"
>
</v-checkbox>

<v-checkbox
v-model="saveInfoOfSourceNewOut"
label="Запоминать откуда отписались ?"
>
</v-checkbox>



</div>


<div slot="additinalLayout" style="margin:20px;  ">



<v-layout wrap align-center justify-center>
   <div style="max-width:350px; min-width:350px" v-for="  item in allForUpdate">

<v-layout style="margin-left:15px;margin-bottom:35px">
     <img  style="border-radius:50%"  width="100" height=100 :src="item.photo_100"></img>
      <div style="margin-left:15px">
       <a target="_blank" :href="item.url">  {{item.name}}  </a>
           <p> Участники:  {{item.members_count}}      </p>

           <v-btn @click="deleteSelectedItem(item)" small color="primary"> Убрать из списка</v-btn>
      </div>
 </v-layout>

   </div>

</v-layout>


</div>



  </app-modalData>

</template>




<script>
import axios from 'axios'
export default {
props: ['modals', 'groups'],
 data: function(){
  return {
   saveInfoOfSourceNewIn: true, // запоминать страницы и указывать куда именно подписались
   saveInfoOfSourceNewOut: false, // Запомнить страницы и указать от куда отписались
   turbo: false,   // использование параллельных запросов на обновление в молнии
   allForUpdate : [],   // читсто что бы посмотреть что выбрал только что если короткая память



    fastUpdating: {
     sensor: 2,
     firstState: {},
     groups: {
       to100: {
         sensitivity: 1,
       },
       to1000: {
         sensitivity: 1,
       },
       to10000: {
         sensitivity: 1,
       },
       to100000: {
         sensitivity: 1,
       },
       from100000: {
         sensitivity: 1,
       },
     },


      auto: false,
      inProccess : false,
      interval: 7,

    },








  starter: true,
  fastAutoParams: false,
  autoparams: false,


  updating: {
    groupName: 'updating',
    intervalSet: {
      sec: 59,
      min: 9,
      hours: 0,
    },
    inProccess : false,
    interval: 7,
    timer: 35,
    auto: false,
    currentPage: 0,
    updatingPercent: 0,
  },


    modalData:{
     sb: {
       snackbar: false,
       color: 'success',
       text: ''
     },
     f: "",
     selectedItem: "followers",
       header:{
         text:"",
          icon:"mdi-database",
         icons:[
         ]
       },
     bar: {
         items:[
           {
              itemName: 'followers',
              text:'Подписчики',
              f: null,

           },
           {
              itemName: 'followers_out',
              text:'Отписки',
              f: null,

           },


         ],
         status: ""
       },
     content:{
       type:'pages',
         items:{

             followers:{
               foundData: {},
               meneger:{}
             },


             followers_out:{
               foundData: {},
               meneger:{}
             },

         },
       },


     operations:{

     }

    },



    contentMenegment: {
      marginTop: '0px',
      snackbarAbsoute: true,
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false},
        autoExportTxt: {active:true},
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        saveSourceInfo: false,
        isActive: false,
        tasksList:[],

      },
       txtAutoExport : {
         pattern: {},
         isActive: false,
       },
     },

     contentMenegmentOut: {
       marginTop: '0px',
       snackbarAbsoute: true,
       items: {
         selector: {active:true},
         copy: {active:true},
         export: {active:true},
         update: {active:false},
         delete: {active:false},
         autoExport: {active:false},
         autoExportTxt: {active:true},
       },
       contentInfo: {
         type: 'pages',
       },
       autoExport: {
         saveSourceInfo: false,
         isActive: false,
         tasksList:[],

       },
       txtAutoExport : {
         pattern: {},
         isActive: false,
       },

      },





  }
},


methods: {

  f(fName){
  eval('this.'+fName+'()')
  },




fastAutoStarter(){
  if(this.fastUpdating.auto){
     this.fastUpdating.auto = false
     this.contentMenegment.items.autoExport.active = false
     this.contentMenegmentOut.items.autoExport.active = false
  } else {

  this.fastAutoParams = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
       method: 'POST',
       data: {
         dataString: this.groups.checkList.join(","),
         dataType: 'groups',
         addInfo: false,
       }
     }).then(response => {
if(response.data){
  this.fastUpdating.firstState = response.data
      response.data.forEach(
        (item,i,arr)=>{
          this.fastUpdating.firstState[item.id] = item
          this.fastUpdating.firstState[item.id].counter = 0
        }
      )

    }
     })
}





},
fastAutoStart(){
  this.contentMenegment.items.autoExport.active = true
  this.contentMenegmentOut.items.autoExport.active = true
  this.fastUpdating.auto = true
   this.fastAutoParams = false
   this.autoFastRunner()

},


autoFastRunner (){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
       method: 'POST',
       data: {
         dataString: this.groups.checkList.join(","),
         dataType: 'groups',
         addInfo: false,
       }
     }).then(response => {

if(!this.updating.inProccess){
   if(response.data && this.fastUpdating.firstState.length>0){


       response.data.forEach((item,i,arr) => {

       if(item.members_count <= 100) {

         let diff =  item.members_count - this.fastUpdating.firstState[item.id].members_count
         this.fastUpdating.firstState[item.id].members_count = item.members_count
         if(diff > 0) {
           this.fastUpdating.firstState[item.id].counter +=  diff
           if(this.fastUpdating.firstState[item.id].counter >= this.fastUpdating.groups.to100.sensitivity){
              this.updaterMembers(item.id)
              this.fastUpdating.firstState[item.id].counter = 0
           }
         }
       }
       if(item.members_count <= 1000) {
         let diff =  item.members_count - this.fastUpdating.firstState[item.id].members_count
         this.fastUpdating.firstState[item.id].members_count = item.members_count
         if(diff > 0) {
           this.fastUpdating.firstState[item.id].counter +=  diff
           if(this.fastUpdating.firstState[item.id].counter >= this.fastUpdating.groups.to1000.sensitivity){
              this.updaterMembers(item.id)
              this.fastUpdating.firstState[item.id].counter = 0
           }
         }
       }
       if(item.members_count <= 10000) {
         let diff =  item.members_count - this.fastUpdating.firstState[item.id].members_count
         this.fastUpdating.firstState[item.id].members_count = item.members_count
         if(diff > 0) {
           this.fastUpdating.firstState[item.id].counter +=  diff
           if(this.fastUpdating.firstState[item.id].counter >= this.fastUpdating.groups.to10000.sensitivity){
              this.updaterMembers(item.id)
              this.fastUpdating.firstState[item.id].counter = 0
           }
         }
       }
       if(item.members_count <= 100000) {
         let diff =  item.members_count - this.fastUpdating.firstState[item.id].members_count
         this.fastUpdating.firstState[item.id].members_count = item.members_count
         if(diff > 0) {
           this.fastUpdating.firstState[item.id].counter +=  diff
           if(this.fastUpdating.firstState[item.id].counter >= this.fastUpdating.groups.to100000.sensitivity){
              this.updaterMembers(item.id)
              this.fastUpdating.firstState[item.id].counter = 0
           }
         }
       }
       if(item.members_count > 100000) {

       let diff =  item.members_count - this.fastUpdating.firstState[item.id].members_count
       this.fastUpdating.firstState[item.id].members_count = item.members_count
       if(diff > 0) {
         this.fastUpdating.firstState[item.id].counter +=  diff
         if(this.fastUpdating.firstState[item.id].counter >= this.fastUpdating.groups.from100000.sensitivity){
            this.updaterMembers(item.id)
            this.fastUpdating.firstState[item.id].counter = 0
         }
       }

       }

       })
    } else {
     //  this.fastUpdating.auto = false
      this.modalData.sb.snackbar = true
      this.modalData.sb.color = 'red'
      this.modalData.sb.text = 'Ошибка -  обновите страницу, проверьте аккаунты'

    }
   }

   if(this.fastUpdating.auto){let repeat = setTimeout( ()=>{this.autoFastRunner()}, this.fastUpdating.sensor*1000)}

     })


},









  changeTimer(){
    this.updating.interval = this.updating.intervalSet * 60

    this.autoparams = false

  },


  autoUpdaterStarter(){
    if(this.updating.auto){
      this.contentMenegment.items.autoExport.active = false
      this.contentMenegmentOut.items.autoExport.active = false
      this.autoparams = false
      this.autoUpdaterOn()
    } else { this.autoparams = true }

  },
  autoUpdaterStart(){
    this.contentMenegment.items.autoExport.active = true
    this.contentMenegmentOut.items.autoExport.active = true
    this.updating.interval = this.updating.intervalSet.sec + (this.updating.intervalSet.min * 60 ) + (this.updating.intervalSet.hours * 60 *60)
    this.autoparams = false
    this.autoUpdaterOn()

  },



  autoUpdaterOn(){

    if(this.updating.auto){
      this.updating.auto = false
      this.updating.timer == 'off'

      this.contentMenegment.items.autoExport.active = false
      this.contentMenegmentOut.items.autoExport.active = false
    } else {

      this.contentMenegment.items.autoExport.active = true
      this.contentMenegmentOut.items.autoExport.active = true

      this.updating.auto = true
      this.updating.timer = 'on'
    }
  },


updaterMembers(groupId){
 this.starter = false
 this.updating.inProccess = true
 this.updating.groupName = groupId //this.groups.checkList[groupId].name

        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_check.php', {
             method: 'POST',
             data: {id: groupId, turbo: this.turbo, saveInfoOfSourceNewIn: this.saveInfoOfSourceNewIn, saveInfoOfSourceNewOut:this.saveInfoOfSourceNewOut }
           }).then(response => {

if( response.data  === false){
  this.modalData.sb.text = 'ошибка обновления, что то пошло не так ... скорее всего лимиты на обновления или все аккаунты блокнуты'
  this.modalData.sb.color = 'red'
  this.modalData.sb.snackbar = true
}

if(!this.fastUpdating.auto){
// offset current group
    if(this.updating.currentGroup <= this.groups.checkList.length){
     this.updaterMembers(this.groups.checkList[++this.updating.currentGroup])
     if(this.updating.currentGroup <= this.groups.checkList.length){this.updating.updatingPercent = this.updating.currentGroup / this.groups.checkList.length  * 100}

    } else {
       this.updating.currentGroup  = 0
       this.updating.inProccess = false
     }
}
     if(this.fastUpdating.auto) {   this.updating.inProccess = false }

            if(typeof response.data.in !== 'undefined' ) {
              this.groups.checker.foundData.foundIds = this.groups.checker.foundData.foundIds.concat(response.data.in)

              if(this.contentMenegment.autoExport.isActive){
                if(this.contentMenegment.autoExport.saveSourceInfo){

                }
                axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
                     method: 'POST',
                     data: {
                     useSourceInfo: this.contentMenegment.autoExport.saveSourceInfo,
                     sorceType: 'groups',
                     sourceDesc: 'Новый подписчик сообщества',
                     source: groupId,
                     taskIds: this.contentMenegment.autoExport.tasksList,
                     data: response.data.in
                     }
                   }).then(response => {

                   })

              }
                            if(this.contentMenegment.txtAutoExport.isActive){
                              axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/txt/import.php', {
                                   method: 'POST',
                                   data: {
                                   type: 'pages',
                                   txt: this.contentMenegment.txtAutoExport.pattern,
                                   ids: response.data.in
                                   }
                                 })

                            }

            }
            if(typeof response.data.out !== 'undefined' ) {

              this.groups.checker.foundDataOut.foundIds = this.groups.checker.foundDataOut.foundIds.concat(response.data.out)
              if(this.contentMenegmentOut.autoExport.isActive){
                axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
                     method: 'POST',
                     data: {
                     taskIds: this.contentMenegmentOut.autoExport.tasksList,
                     data: response.data.out
                     }
                   })

              }
              if(this.contentMenegmentOut.txtAutoExport.isActive){
                axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/txt/import.php', {
                     method: 'POST',
                     data: {
                     type: 'pages',
                     txt: this.contentMenegmentOut.txtAutoExport.pattern,
                     ids: response.data.out
                     }
                   })

              }

            }

          }).catch(()=>{
            setTimeout(()=>{this.updaterMembers(groupId)}, 3000)
          })



},

reUpdater(){
   this.updaterMembers(this.groups.checkList[this.updating.currentGroup])
},


closeUpdater(){
  this.groups.modals.checkGroup = false
  this.groups.selector = false
  this.updating.auto = false
  this.fastUpdating.auto = false




},

infoOfSelecteted(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
       method: 'POST',
       data: {
         dataString: this.groups.checkList.join(","),
         dataType: 'groups',
         addInfo: false,
       }
     }).then(response => {
       this.allForUpdate = response.data
 })


},

deleteSelectedItem(item){
  if(this.groups.checkList.length > 1){
  this.groups.checkList.splice( this.groups.checkList.indexOf(item.id), 1 )
} else {
  this.modalData.sb.snackbar = true
  this.modalData.sb.color = 'red'
  this.modalData.sb.text = 'Нельзя удалить все сообщества из списка, иначе просто нечего будет отслеживать '
}
},


},

computed: {

  metaData(){
    if(this.groups.modals.checkGroup){
    this.starter = true
     this.updating.currentGroup  = 0

      this.modalData.header.text = 'Новые подписчики выбранных сообществ'

      this.modalData.content.items.followers.foundData = this.groups.checker.foundData
      this.modalData.content.items.followers.meneger =  this.contentMenegment

      this.modalData.content.items.followers_out.foundData = this.groups.checker.foundDataOut
      this.modalData.content.items.followers_out.meneger = this.contentMenegmentOut
      this.infoOfSelecteted()

      return this.modalData
    } else return false
    },

    autoUpdater(){

       if(this.updating.timer > 0 ) {
         if(this.updating.auto){
     setTimeout( ()=>{
          if(!this.updating.inProccess ){
            --this.updating.timer
          } else {
            --this.updating.timer
            ++this.updating.timer
          }
         }, 1000)
      return this.updating.timer
    }  else {
       this.updating.timer = this.updating.interval
       return this.updating.timer
    }
  } else if (this.updating.timer == 'off') {
    this.updating.timer = this.updating.interval
    return false
  } else if (this.updating.timer == 'on') {
    this.updating.timer = this.updating.interval
    return this.autoUpdater
  }  else  {
       this.reUpdater()
       this.updating.timer = this.updating.interval
       return  this.autoUpdater
    }
    },


},


}
</script>

<style  >

</style>
